module.exports = __webpack_public_path__ + "img/relationship.87cb5c22.svg";